
export default {
  name: 'HelloWorld'
}
